// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__31Blr","tab":"ProcedureTabs_tab__2GTEI"};